import { render, staticRenderFns } from "./PasiTable.vue?vue&type=template&id=5d8f73d7&"
import script from "./PasiTable.vue?vue&type=script&lang=js&"
export * from "./PasiTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports